import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import styles from './Auth.module.css';

export default function ForgotPassword() {
  const [email,   setEmail]   = useState('');
  const [loading, setLoading] = useState(false);
  const [sent,    setSent]    = useState(false);
  const [error,   setError]   = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    if (error) setError(error.message);
    else setSent(true);
    setLoading(false);
  };

  if (sent) return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>Run<span>Staff</span>Run</div>
        <div className="success-msg">
          Check your email — we sent a password reset link to <strong>{email}</strong>.
        </div>
        <p className={styles.switch} style={{ marginTop: 24 }}>
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>Run<span>Staff</span>Run</div>
        <h1 className={styles.heading}>Reset your password</h1>
        <p className={styles.sub}>Enter your email and we'll send you a reset link.</p>

        <form onSubmit={handleSubmit} className={styles.form}>
          {error && <div className="error-msg">{error}</div>}
          <div className="form-group">
            <label>Email address</label>
            <input
              className="form-input"
              type="email" required
              placeholder="you@company.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>
          <button className="btn btn-primary btn-full" type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <p className={styles.switch}>
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
